// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export const ClientTypeEnum =
{
    WebDesktop: 15,
    WebInvesting: 25,
    WebMobile: 27,
}
Object.freeze(ClientTypeEnum);

class _ClientType
{
    #currentClientType;

    constructor()
    {
        this.#currentClientType = ClientTypeEnum.WebDesktop;
    }

    getClientType ()
    {
        return this.#currentClientType;
    }

    setIsWebMobile ()
    {
        this.#setClientType(ClientTypeEnum.WebMobile);
    }

    #setClientType (clientType)
    {
        this.#currentClientType = clientType;
    }
}

export const ClientType = new _ClientType();
